<template>
  <a-modal
    title="佣金记录"
    :visible="visible"
    width="60%"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭" >
    <a-card :bordered="false">
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 800}"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

  </a-modal>
</template>

<script>

import { pageUserByTopUser } from '@/api/user/brokerage'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'UserForm',
  components: {

  },
  mixins: [tableMixin],

  data() {
    return {
      advanced: false,
      visible: false,
      multiple: false,
      list: [],
      // 展开的行，受控属性
      expandedRowKeys: [],
      replaceFields: {
        id: 'id',
        pid: 'pid',
        children: 'childList'
      },
      sortParams: {
        field: 'sort',
        way: 'ASC'
      },
      selectedRowKeys: [],
      selectedRows: [],

      ids: [],
      loading: false,
      total: 0,
      headId: null,
      // 查询参数
      queryParam: {
        userId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'nickname',
          width: 120,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          width: 180,
          align: 'center'
        },
        {
          title: '佣金合计',
          dataIndex: 'totalMoney',
          width: 120,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    // this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    show(record) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.visible = true
      this.multiple = false
      this.queryParam.userId = record.userId
      this.getList()
    },
    /** 查询引用列表 */
    getList() {
      this.loading = true
      pageUserByTopUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getHeadList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleOk() {
      this.visible = false
      this.$emit('ok')
    },
    handleCancel() {
      this.visible = false
      this.$emit('ok')
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getHeadList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getHeadList()
    },
    handleDetail(rowData) {
      this.$refs.storeUserInfo.initValue(rowData)
      this.$refs.storeUserInfo.title = '用户详情'
      this.$refs.storeUserInfo.visible = true
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      if (this.ids.length < 1) {
        that.$message.error(
          '请选择数据',
          3
        )
        return
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delBuilding(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getBuildingList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
<style lang='less' scoped></style>
